<template>
  <div class="spl-parcel-list-controls">
    <!-- Hidden_Feature   <div class="spl-parcel-list-controls__save-template" :class="{'spl-parcel-list-controls__save-template-active': saveTemplateIsOpen}" v-on:click="toggleSaveTemplate"></div> -->
    <div
      :class="{'spl-parcel-list-controls__show-columns-active': showColumnsIsOpen}"
      class="spl-parcel-list-controls__show-columns"
      @click.self="toggleShowColumns">
      <div :class="{'spl-parcel-list-controls__show-columns-overlay-open': showColumnsIsOpen}" class="spl-parcel-list-controls__show-columns-overlay">
        <div class="spl-parcel-list-controls__show-columns-overlay__header row">
          <div class="col4 sm-col12 spl-parcel-list-controls__show-columns-overlay__header__label">
            Visible columns
          </div>
          <div class="col8 sm-col12 spl-parcel-list-controls__show-columns-overlay__header__buttons">
            <form-button @onClick="toggleShowColumns">
              Apply
            </form-button>
            <!--form-button secondary="true">Save as default</form-button-->
          </div>
        </div>
        <div class="spl-parcel-list-controls__show-columns-overlay__options row">
          <div v-for="(columnGroup, groupIndex) in columnGroups" :key="'parcelListControlsColums' + groupIndex">
            <div class="row">
              <div class="spl-column-group-header">
                <form-checkbox :checked="isColumnGroupSelected(columnGroup)" @checkboxChanged="toggleColumnGroup(columnGroup, groupIndex)">
                  {{ columnGroups[groupIndex].label }}
                </form-checkbox>
              </div>
              <hr>
              <div
                v-for="(column, columnIndex) in getColumns(columnGroup.columns)"
                :key="'parcelListControlsSubColumns' + columnIndex"
                class="col4 sm-col6">
                <form-checkbox
                  :checked="column.selected"
                  :class="'parcel-list-controls__' + kebabCase(column.name)"
                  @checkboxChanged="toggleColumn(column.selected, [groupIndex, columnIndex])">
                  {{ column.label }}
                </form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="activePage !== 'dashboard'"
      :class="{'spl-parcel-list-controls__expand-active': parcelListExpanded}"
      class="spl-parcel-list-controls__expand"
      @click="expandList" />
    <div
      v-if="activePage !== 'dashboard'"
      :class="{'spl-parcel-list-controls__contract-active': !parcelListExpanded}"
      class="spl-parcel-list-controls__contract"
      @click="contractList" />
  </div>
</template>

<script>
import { kebabCase, filter } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'ParcelListTableControls',
  props: [
    'parcelListExpanded',
    'columnGroups',
    'activePage'
  ],
  data () {
    return {
      showColumnsIsOpen: false,
      saveTemplateIsOpen: false,
      kebabCase
    }
  },
  computed: {
    ...mapGetters('parcelFilter', ['parcelFilter'])
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickOutside)
  },
  methods: {
    getColumns (columns) {
      if (this.activePage === 'dashboard' && !this.parcelFilter('dashboard').Show_Forward_Flow) {
        return filter(columns, (column) => { return column.showInReturn })
      } else {
        return columns
      }
    },
    toggleColumn (isSelected, indexes) {
      // Toggles a column
      // TODO: I don't like the index part (should be done with constants / keys)
      this.$emit('toggleColumn', !isSelected, indexes)
    },
    toggleSaveTemplate () {
      this.$emit('toggleSaveTemplate')
      this.saveTemplateIsOpen = !this.saveTemplateIsOpen
    },
    clickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.showColumnsIsOpen = false
      }
    },
    toggleShowColumns () {
      this.showColumnsIsOpen = !this.showColumnsIsOpen
      if (this.showColumnsIsOpen) {
        setTimeout(() => {
          document.addEventListener('click', this.clickOutside)
        }, 100)
      } else {
        document.removeEventListener('click', this.clickOutside)
      }
    },
    // Toggles a complete group (if one thing is unselected selects the whole group first then unselects everything)
    toggleColumnGroup (columnGroup, groupIndex) {
      var direction = !this.isColumnGroupSelected(columnGroup)
      for (let i = 0; i < columnGroup.columns.length; i++) {
        this.$emit('toggleColumn', direction, [groupIndex, i])
      }
    },
    // Returns if everything in the group is selected
    isColumnGroupSelected (columnGroup) {
      var selected = true
      for (let i = 0; i < columnGroup.columns.length; i++) {
        const column = columnGroup.columns[i]
        if (!column.selected) { selected = false }
      }
      return selected
    },
    expandList () {
      this.$emit('expandList')
    },
    contractList () {
      this.$emit('contractList')
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-list-controls {
        margin-bottom: 30px;
        position: relative;

        &__contract,
        &__expand,
        &__show-columns,
        &__save-template {
            background-position: center center;
            background-repeat: no-repeat;
            border: 2px solid $parcelListControlsBorderColor;
            border-radius: 50%;
            cursor: pointer;
            float: right;
            height: 34px;
            margin-left: 10px;
            width: 34px;

            &-active {
                background-color: $mainTextColor;
            }
        }
        &__contract {
            background-image: url(../../assets/icon-contract.svg);

            &-active {
                background-image: url(../../assets/icon-contract-active.svg);
            }
        }
        &__expand {
            background-image: url(../../assets/icon-expand.svg);

            &-active {
                background-image: url(../../assets/icon-expand-active.svg);
            }
        }
        &__save-template {
            background-image: url(../../assets/icon-save-template.svg);
            background-position: 7px center;
            background-size: 20px 18px;

            &-active {
                background-color: $middleYellow;
                background-image: url(../../assets/icon-save-template-active.svg);
            }
        }
        &__show-columns {
            background-image: url(../../assets/icon-show-columns.svg);

            &-active {
                background-color: $middleYellow;
                background-image: url(../../assets/icon-show-columns-active.svg);
            }
        }
        &__show-columns-overlay {
            background-color: $mainTextColor;
            box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.5);
            cursor: auto;
            display: none;
            opacity: 0;
            padding: 40px 30px 50px 30px;
            pointer-events: none;
            position: absolute;
            right: -19px;
            top: 50px;
            transition: opacity $shortTransition ease-in-out;
            width: 590px;
            z-index: 3000;

            @include mobile() {
                padding: 20px $mobilePadding;
                right: 0;
                width: 100%;
            }
            &:before {
                border-style: solid;
                border-width: 0 8px 9px 8px;
                border-color: transparent transparent $mainTextColor transparent;
                content: '';
                height: 0;
                position: absolute;
                right: 29px;
                top: -9px;
                width: 0;
            }
            &-open {
                display: block;
                opacity: 1;
                pointer-events: auto;
            }
            &__header {
                &__label {
                    color: $headerLatestUpdatesLabelColor;
                    font-size: 16px;
                    font-weight: 600;
                    margin-top: 10px;

                    @include mobile() {
                        margin-bottom: 10px;
                    }
                }
                &__buttons {
                    padding: 0;

                    .spl-button {
                        float: right;
                        margin: 0 0 0 15px;

                        @include mobile() {
                            margin-left: 10px;
                            padding: 5px 15px;
                            width: calc(50% - 5px);

                            &-secondary {
                                margin-left: 0;
                            }
                        }
                    }
                }
            }
            &__options {
                padding-top: 0px;

                @include mobile() {
                    padding-top: 25px;
                }
                .spl-column-group-header {
                    margin-top: 15px;
                    margin-bottom: 5px;
                    padding: 0;
                    color: $tableHeaderLabel;
                }
                hr {
                  margin-bottom: 10px;
                  padding: 0;
                  border-color: $tableHeaderLabel;
                }
                .spl-checkbox-group__item__label {
                    cursor: pointer;
                    display: block;
                    margin-bottom: 3px;

                    &:hover {
                        .spl-checkbox {
                            border-color: $middleYellow;
                        }
                        span {
                            color: #fff;
                        }
                    }
                    .spl-checkbox {
                        background-color: transparent;
                        border: 1px solid $parcelListControlsShowColumnsOptions;

                        &:checked {
                            background-color: $mainInputColor;
                            border-color: $middleYellow;

                            &:after {
                                background-image: url(../../assets/icon-checkmark-yellow.svg);
                            }
                        }
                    }
                    span {
                        color: $parcelListControlsShowColumnsOptions;
                        transition: color $shortTransition ease-in-out;
                    }
                    &-checked span {
                        color: #fff;
                    }
                }
            }
        }
    }
</style>
